import { IInvoice } from "@wingspanhq/payments/dist/interfaces";
import { IInvoiceRow } from "../../modules/Invoicing/service";

export const calculateAmountAvailableToRefund = (
  invoice: IInvoice | IInvoiceRow
) => {
  return invoice.amount - (invoice.amountDetails?.clientRefunded ?? 0);
};
